import { PoMicroFrontend } from 'micro-frontend.react';


/**
 * Renders a modal for selecting an employee type, such as a global employee or a local employee.
 *
 * @param isOpen - Whether the modal should be open or not.
 * @param onClose - A function to call when the modal is closed.
 *
 * @returns A JSX element representing the modal.
 */
export const EmployeeTypeSelectionModal = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {

	return (
		<PoMicroFrontend
			customClassNamePrefix="global-employee-type-selection-modal"
			isOpen={isOpen}
			onClose={onClose}
			route="/global-employment/new-employee-modal"
		/>
	);
}
